module.exports = __webpack_public_path__ + "static/media/logo.751ecd3d.png";